import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom';

import { Form, Card } from 'react-bootstrap';
import { validarEntorno } from '../../../../helpers/validarHost';
import NotificationModal from '../../../modales/NotificationModal'


export const AprobarSolicitudDesbloqueo = ({ele}) => {

  const [tipoNotificacion, setTipoNotificacion] = useState({
    tipo: '',
    mensaje: ''
  })

  const { id } = useParams()


  const [changeForm, setChangeForm] = useState({
    aprobacion: '',
    observacion: ''
  })

  const [confirmacionEnvio, setConfirmacionEnvio] = useState(false)

  useEffect(() => {
    setChangeForm({
      aprobacion: ele.valuesInputs.aprobacion || '',
      observacion: ''
    })
  }, [])

  const handleChange = ({target}) => {
    setChangeForm({
      ...changeForm,
      [target.name]: target.value
      
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const data = {
      hash: window.location.hash,
      idSolicitud: id,
      formData: changeForm
    }



    const envioSolicitudObservacion = await validarEntorno('JSON/aprobar_sol_des_inv.html', 'POST', data)

    if(envioSolicitudObservacion.ok){


      const respuesta = await envioSolicitudObservacion.json()

      if(respuesta.solicitud === 'ok'){
        setConfirmacionEnvio(true)
        setTipoNotificacion({...tipoNotificacion, tipo: 'crearSolicitud'})
        setChangeForm({
          aprobacion: `${respuesta.aprobacion}`,
          prioridad: respuesta.prioridad,
          observacion: `${respuesta.observacion}`
        })
      }else if(respuesta.solicitud === 'error'){
        setConfirmacionEnvio(true)
        setTipoNotificacion({...tipoNotificacion, tipo: 'ErrorCrearSolicitud', mensaje: respuesta.mensaje })
      }

    }

  }

  const recargarGestor = () => {
    window.location.reload()
  }
  

  return (
    <>
      <Card className='shadow cardUnderPestana'>

        <Card.Body>
        <h5 className='titleCard'>Aprobación de solicitud de desbloqueo de investigación</h5>
        <br/>
        <div className='contenedorTextAreaGeneral'>
          <Form onSubmit={handleSubmit}>
            <div style={{display:'flex',  }}>
              <Form.Group  style={{display:'flex', flexDirection:'column', alignItems:'flex-start', width:'50%', marginRight: '12px' }}>
                <Form.Label className='observacionesLabel' style={{marginLeft: '0px'}}>
                    Confirmación de aprobación *
                </Form.Label>
                <Form.Control 
                  required
                  // className='textAreaGeneral' 
                  name='aprobacion' 
                  id='observacionesTextArea' 
                  as='select'
                  placeholder='Observaciones'
                  onChange={(e) => handleChange(e)}
                  style={{width:'100%'}}
                  disabled={!ele.editar}
                  defaultValue={ele.valuesInputs.aprobacion}
                >
                  <option value='' disabled>--Seleccione una opción--</option>
                  {/* <option>Pendiente de aprobación</option> */}
                  <option>Aprobar</option>
                  <option>No aprobar</option>
                </Form.Control>
                <Form.Control.Feedback type='invalid'>Seleccione el estado de la aprobación</Form.Control.Feedback>
              </Form.Group>

              

            </div>
            <br/>
            <Form.Group className='formGroupTextArea'>
              <Form.Label className='observacionesLabel' style={{marginLeft: '0px'}}>
                  Observaciones
              </Form.Label>
              <Form.Control 
                className='textAreaGeneral' 
                name='observacion' 
                id='observacionesTextArea' 
                as='textarea'
                placeholder='Observaciones'
                onChange={(e) => handleChange(e)}
                disabled={!ele.editar}
                defaultValue={ele.valuesInputs.observaciones}
              ></Form.Control>
              <Form.Control.Feedback type='invalid'>Ingresa las observaciones</Form.Control.Feedback>
            </Form.Group>
            <div className='buttonContainer' id='confirmButtonAddBeneficiarioContainer'>
                { changeForm.aprobacion !== ''
                    ?
                    <button type="submit" className='botonAddBeneficiario confirmButton'>
                        Guardar
                    </button>
                    :
                    <button disabled className='botonAddBeneficiario botonDeshabilitado'>
                      Para realizar una aprobación, diligencie los campos de la solicitud.
                    </button>
                }
                
            </div>

          </Form>
        </div>
        </Card.Body>
      </Card>
      <NotificationModal 
        typeModal={tipoNotificacion.tipo} 
        isOpen={confirmacionEnvio} 
        setIsOpen={setConfirmacionEnvio} 
        recargar={recargarGestor}
        mensaje={tipoNotificacion.mensaje}
      />
    </>
  )
}
